import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "form-hint"
};
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
import { CERTIFICATE_GET_METHODS } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    return function (_ctx, _cache) {
      var _component_a_select = _resolveComponent("a-select");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfCertificateGetMethod.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "证书获取方式：",
            name: "certificateGetMethod"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_select, {
                allowClear: "",
                size: "large",
                value: _unref(formState).certificateGetMethod,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).certificateGetMethod = $event;
                }),
                options: _unref(CERTIFICATE_GET_METHODS),
                placeholder: "证书获取方式"
              }, null, 8, ["value", "options"])];
            }),
            _: 1
          }), _unref(formState).certificateGetMethod === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_1, " 可在活动官网->个人中心页查询获奖证书，活动官网地址：https://match.hetao101.com/ ")) : _createCommentVNode("", true)];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});